/* RESPONSIBLE TEAM: team-actions */
import { attr } from '@ember-data/model';
import Fragment from 'ember-data-model-fragments/fragment';

export default class RefreshTokenConfigurationHeader extends Fragment {
  @attr('string') name;
  @attr('string') value;
}
